import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { openWhatsAppGroup } from "@/utils/whatsapp";
import { useToast } from "@/hooks/use-toast";
import { useTracking } from "@/hooks/useInteractionTracking";

interface EventActionsProps {
  whatsappGroup?: string;
}

const EventActions = ({ whatsappGroup }: EventActionsProps) => {
  const { toast } = useToast();
  const { trackClick } = useTracking();

  const handleWhatsAppClick = () => {
    trackClick("whatsapp_event_group", { hasGroup: !!whatsappGroup });
    if (whatsappGroup) {
      openWhatsAppGroup(whatsappGroup);
    } else {
      toast({
        title: "WhatsApp Group Unavailable",
        description: "The group link is not available at the moment.",
        variant: "destructive",
      });
    }
  };

  return (
    <Button
      variant="outline"
      className="w-full mt-8 mb-4 gap-2"
      onClick={handleWhatsAppClick}
    >
      <MessageCircle className="w-4 h-4" />
      Join Event Chat
    </Button>
  );
};

export default EventActions;